import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  addSheetTitle,
  applyBorderPattern,
  formatPercent,
  outerRowPatterns,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { normalizeOtherRows } from "./principle5SheetHelpers.js";

export const SHEET_NAME = "Details of other value chain";

const SHEET_TITLE = "Details of other assessments of value chain partner";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 9.1796875,
  E: 60.7265625,
  F: 48.453125,
  G: 9.1796875,
  H: 9.1796875,
  I: 14.81640625,
  J: 9.1796875,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_F;

const HEADER_BORDERS = ["tttt", "tttt", "tttt"];
const DATA_BORDERS = HEADER_BORDERS;

const HEADERS = [
  { col: COL_D, label: "Sr. No.", bold: false },
  { col: COL_E, label: "Name of other assessment", bold: true },
  {
    col: COL_F,
    label:
      "% of value chain partners (by value of business done with such partners) that were assessed",
    bold: true,
  },
];

function safeText(value, fallback = "") {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
}

export function buildDetailsOfOtherValueChainSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 7);

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_5, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    borderPatterns: outerRowPatterns(COL_D, COL_END),
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, HEADER_BORDERS);
  ws.getRow(HEADER_ROW).height = 39;
  HEADERS.forEach(({ col, label, bold }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: !!bold,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, HEADER_BORDERS);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 58;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  applyBorderPattern(ws, SPACER_ROW, COL_D, outerRowPatterns(COL_D, COL_END));
  for (let col = COL_D; col <= COL_END; col += 1) {
    const cell = ws.getCell(SPACER_ROW, col);
    if (!cell.font) cell.font = BODY_FONT;
  }
  ws.getRow(SPACER_ROW).height = 30;

  const leadership = sectionC?.principle5?.leadershipIndicator || {};
  const rows = normalizeOtherRows(leadership?.other);
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        {
          col: COL_D,
          value: idx + 1,
          align: "right",
          fill: null,
          font: BODY_FONT,
          vertical: "top",
        },
        {
          col: COL_E,
          value: safeText(item?.name),
          align: "left",
          fill: VALUE_FILL,
          vertical: "top",
        },
        {
          col: COL_F,
          value: formatPercent(item?.percentage),
          align: "center",
          fill: VALUE_FILL,
        },
      ],
      { patterns: DATA_BORDERS }
    );
    ws.getCell(row, COL_D).alignment = {
      horizontal: "right",
      vertical: "top",
      wrapText: true,
    };
    ws.getCell(row, COL_E).alignment = {
      horizontal: "left",
      vertical: "top",
      wrapText: true,
    };
  });

  return ws;
}
